define('root/Assets/Templates/Html/Menu/Js/Menu',[
	'jquery',
	'base/MbiMediaQuery',
	'base/MbiHelper',	
	'root/Assets/Js/Vendor/cookie',
	'project/Vendor/lib/greensock/TweenMax',
	'project/Vendor/lib/greensock/plugins/ScrollToPlugin',
	'project/Vendor/ScrollMagic',
	'project/Vendor/gsap',
	'project/Vendor/addIndicators',
	'root/Assets/Templates/Html/Menu/Js/Module/MenuToggleHandler',
	'root/Assets/Templates/Html/Menu/Js/Module/scrollStateHandler'
	
], function(
	$,
	mbiMq,
	_,
	
	Cookies,
	tm,ScrollToPlugin,ScrollMagic,gsap

)
{
	var scrollTo = 0;
	$(document).on('click', '.js_nav_scroll', function(){
		$('body').addClass('scrolled');
	});

	$(document).on('click', '.footer__job-anchor', function(){
		
		$('body').removeClass('has_sidebar--open');
		
	});
	$(document).on('click', '.js_contactFooter', function(){
		
		$('.js_contact').trigger('click');
		
	});
	
	$(document).on('click', '.js_close--sticky', function(){
				
		if('lap-' in mbiMq.mqArea) {
			$(window).scrollTop(scrollTo);
			$('body').addClass('is_scrolled');
			
		}
		$('body').toggleClass('has_sticky--open');
		
	});
	$(document).on('click', '.js_sticky', function(){
		$('body').toggleClass('has_sticky--open');

		if('lap-' in mbiMq.mqArea) {
			
			$('body').removeClass('is_scrolled');
			scrollTo = $(window).scrollTop();
			$(window).scrollTop(-50);
						
		}
		
	});
	
	$(window).on('resize', function(){
		if('pad+' in mbiMq.mqArea) {
			$('body').removeClass('has_sidebar--open');
		}
	});


	var controller = new ScrollMagic.Controller({globalSceneOptions: {}});
	var initScroll = function() {
		$('.is_scrolled .js_scrollmagic_header').each(function(){
					
			
			var height =$(this).outerHeight;
			console.log(this);
			
			var generalScene = new ScrollMagic.Scene({
					duration: height,
					triggerHook: 'onCenter',								
					triggerElement: this })
							
				.setTween(TweenMax.fromTo(this, 1, {css: {height: '100vh', top:'0' }}, {css: {height: '0', top: '100vh'}}))
				.addTo(controller); 
			var element = $(this).find('.navigation__logo');
			var secondScene = new ScrollMagic.Scene({
					duration: height,
					triggerHook: 'onCenter',
					
					triggerElement: this })
				.setTween(TweenMax.to(element, 1, {position: 'fixed',ease:'Power4.easeInOut'}))
				.addTo(controller); 		

		});
	};
	$('body').on('scrolled', function(){
		if ($(window).width() > 1023) {
			if ($('body').hasClass('is_scrolled')) {

				initScroll();
			}
			
			$('body:not(.srolled)').addClass('scrolled');
		} else {
			$('body').removeClass('scrolled').removeClass('is_scrolled');
		}
	});
	$('body').on('scrollTop', function(){
		
		$('body').removeClass('is_scrolled');
		
	});

	//cookies
	var showCookieAppearance = false;
	var showCookieAppearanceSet = true;
	if (_.exists('.js_cookie')) {
		if (typeof Cookies.get('BonstinglAt')==='undefined') {
			showCookieAppearance = true;
		}
	}

	if(showCookieAppearance && showCookieAppearanceSet) {
		showCookieAppearanceSet = false;
		$('.js_cookie').addClass('is_active');
	}

	$(document).on('click', '.js_close-cookie', function(){

		$(this).parents('.js_cookie').removeClass('is_active');
		setTimeout(function(){
			$('.js_cookie').css('display','none');
		},700)

	});
	$(document).on('click', '.js_agree-cookie', function(){
		$('.js_close-cookie').trigger('click');
		Cookies.set('BonstinglAt', 'bonstingl', { expires: 365, path: '/' });
	});

	$(document).on('click', '.js_sidebar-close', function(){
		
		$('body').removeClass('has_sticky--open');
		$('body').removeClass('has_overlay--open');
	});

	
});
